import * as React from "react";
import styled, { css } from "styled-components";

interface IProps {
  status?: "active" | "suspended" | "deactivated" | "deleted";
}

interface IStatusWrapper {
  status?: string;
}

const StatusWrapper = styled("span")<IStatusWrapper>`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  text-transform: capitalize;
  ${({ status }) => StatusCss(status)};
`;

const DefaultCss = css`
  color: inherit;
`;

const ActiveCss = css`
  color: ${({ theme }) => theme.colors.success};
`;

const SuspendedCss = css`
  color: ${({ theme }) => theme.colors.warn};
`;

const DeactivatedCss = css`
  color: ${({ theme }) => theme.colors.error};
`;

// Gives the status the appropriate colour
const StatusCss = (status?: string) => {
  switch (status) {
    case "active":
      return ActiveCss;
    case "suspended":
      return SuspendedCss;
    case "deactivated":
    case "deleted":
      return DeactivatedCss;
    default:
      return DefaultCss;
  }
};

/**
 * Gets the status
 */
export const Status = ({ status }: IProps): JSX.Element => {
  let statusToHuman: string;

  // Only return the status if one is given
  if (status) {
    switch (status) {
      case "active":
        statusToHuman = "Active";
        break;
      case "suspended":
        statusToHuman = "Suspended";
        break;
      case "deactivated":
        statusToHuman = "Deactivated";
        break;
      case "deleted":
        statusToHuman = "Deleted";
        break;
      default:
        statusToHuman = status;
    }

    return (
      <StatusWrapper status={status}>
        {statusToHuman}
      </StatusWrapper>
    );
  }

  return (
    <StatusWrapper>
      -
    </StatusWrapper>
  );
};

export default Status;
